import { render, staticRenderFns } from "./WebsiteHeader.vue?vue&type=template&id=0c0d5374"
import script from "./WebsiteHeader.vue?vue&type=script&lang=js"
export * from "./WebsiteHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports